import { render, staticRenderFns } from "./CompanyContactList.vue?vue&type=template&id=07ba27e9&"
import script from "./CompanyContactList.vue?vue&type=script&lang=js&"
export * from "./CompanyContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports